<mat-toolbar class="topbar gap-1.5">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  @if (showToggle) {
    <button
      mat-icon-button
      (click)="toggleCollapsed.emit()"
      class="flex justify-center items-center"
    >
      <i
        class="iconify text-xl! flex"
        data-icon="solar:sidebar-minimalistic-line-duotone"
      ></i>
    </button>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Mobile Menu -->
  @if (!showToggle) {
    <button
      mat-icon-button
      (click)="toggleMobileNav.emit()"
      class="flex justify-center items-center"
    >
      <i
        class="iconify text-xl! flex"
        data-icon="solar:sidebar-minimalistic-line-duotone"
      ></i>
    </button>
  }
  <!-- --------------------------------------------------------------- -->

  <div class="hidden lg:flex">
    <mat-form-field appearance="outline" class="hide-hint">
      <input matInput placeholder="Rechercher (clients, commandes...)" />
      <mat-icon class="flex items-center justify-center" matSuffix>
        <i
          class="iconify text-xl! flex"
          data-icon="solar:magnifer-line-duotone"
        ></i>
      </mat-icon>
    </mat-form-field>
  </div>

  <span class="flex-1"></span>

  <!-- --------------------------------------------------------------- -->
  <!--  Search -->
  <!-- --------------------------------------------------------------- -->
  <button
    mat-icon-button
    (click)="openDialog()"
    class="flex lg:hidden! items-center justify-center"
  >
    <i class="iconify text-xl! flex" data-icon="solar:magnifer-outline"></i>
  </button>

  @if (options.theme == "light") {
    <button
      mat-icon-button
      aria-label="lightdark"
      class="flex justify-center"
      (click)="setlightDark('dark')"
    >
      <i-tabler class="flex text-xl!" [name]="'moon'"></i-tabler>
    </button>
  } @else {
    <button
      mat-icon-button
      aria-label="lightdark"
      class="flex justify-center"
      (click)="setlightDark('light')"
    >
      <i-tabler class="flex text-xl!" [name]="'sun'"></i-tabler>
    </button>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button [matMenuTriggerFor]="flags" mat-icon-button class="hidden! lg:flex!">
    <img [src]="selectedLanguage.icon" class="rounded-full object-cover" />
  </button>
  <mat-menu #flags="matMenu" class="cardWithShadow" xPosition="before">
    @for(lang of languages; track lang.icon) {
    <button mat-menu-item (click)="changeLanguage(lang)">
      <div class="flex gap-2 items-center">
        <img [src]="lang.icon" class="rounded-full object-cover size-5!" />
        <span class="text-sm">{{ lang.language }}</span>
      </div>
    </button>
    }
  </mat-menu> -->

  <!-- --------------------------------------------------------------- -->
  <!-- Shopping Cart -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button mat-icon-button (click)="toggleShoppingCartNav.emit()" class="flex justify-center items-center relative">
    <i class="iconify text-xl! flex" data-icon="solar:cart-large-minimalistic-line-duotone"></i>
    <div
      class="bg-error text-white text-[10px] h-4 w-4 rounded-full leading-3 flex items-center justify-center absolute right-0.5 top-px rtl:right-auto rtl:left-0.5">
      0
    </div>
  </button> -->

  <!-- --------------------------------------------------------------- -->
  <!-- Badge réseau / sync : ouvre /dinki/sync au clic.                 -->
  <!-- Masqué pour les admins — ils opèrent toujours en ligne sur des  -->
  <!-- données plateforme (plans, ateliers, billing) qui ne tolèrent   -->
  <!-- pas un cache local divergent.                                   -->
  <!-- --------------------------------------------------------------- -->
  @if (!auth.hasRole("ADMIN")) {
    <app-network-badge class="me-2"></app-network-badge>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Sélecteur de langue Dinki -->
  <!-- --------------------------------------------------------------- -->
  <app-language-switcher
    class="hidden! lg:inline-flex!"
  ></app-language-switcher>

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown (centre de notifs Dinki) -->
  <!-- --------------------------------------------------------------- -->
  <button
    mat-icon-button
    [matMenuTriggerFor]="notificationmenu"
    aria-label="Notifications"
    class="hidden! lg:flex! items-center justify-center relative"
  >
    <i class="iconify text-xl! flex" data-icon="solar:bell-line-duotone"></i>
    @if (unreadCount > 0) {
      <div
        class="bg-error text-white text-[10px] h-4 w-4 rounded-full leading-3 flex items-center justify-center absolute right-0.5 top-px rtl:right-auto rtl:left-0.5"
      >
        {{ unreadCount > 9 ? "9+" : unreadCount }}
      </div>
    }
  </button>
  <mat-menu
    #notificationmenu="matMenu"
    class="topbar-dd cardWithShadow"
    xPosition="before"
  >
    <div
      class="flex items-center justify-between px-6 py-3 border-b border-border"
    >
      <h6 class="text-base font-semibold">
        {{ "nav.notifications" | translate }}
      </h6>
      @if (unreadCount > 0) {
        <span
          class="bg-primary text-white px-2 py-1 font-medium rounded-xl text-xs"
        >
          {{ "header.unread_count" | translate: { count: unreadCount } }}
        </span>
      }
    </div>

    @if (appNotifications.length === 0) {
      <div class="text-center text-muted text-sm py-6 px-4">
        <i
          class="iconify text-4xl text-muted block mb-2"
          data-icon="solar:bell-off-line-duotone"
        ></i>
        {{ "header.no_notifications" | translate }}
      </div>
    } @else {
      @for (n of appNotifications; track n.reference) {
        <a
          [routerLink]="n.lien || '/dinki/notifications'"
          mat-menu-item
          class="px-6! py-3!"
        >
          <div class="flex gap-3 items-start text-dark">
            <span
              class="shrink-0 bg-primary/10 text-primary rounded-full size-9! flex items-center justify-center"
            >
              <i
                class="iconify text-base! flex"
                [attr.data-icon]="
                  'solar:' + (notifIcons[n.type] || 'bell') + '-line-duotone'
                "
              ></i>
            </span>
            <div class="w-full min-w-0">
              <h5 class="text-sm font-semibold truncate">{{ n.titre }}</h5>
              <span class="block text-truncate text-xs text-muted">{{
                n.message
              }}</span>
            </div>
            @if (!n.lue) {
              <span class="size-2 bg-primary rounded-full mt-2 shrink-0"></span>
            }
          </div>
        </a>
      }
    }

    <div class="py-3 px-6 border-t border-border">
      <a
        mat-flat-button
        color="primary"
        class="w-full"
        routerLink="/dinki/notifications"
      >
        Toutes les notifications
      </a>
    </div>
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- Collpase bar -->
  <!-- --------------------------------------------------------------- -->
  <button
    mat-icon-button
    (click)="toggleCollpase()"
    class="flex lg:hidden! justify-center"
  >
    <i class="iconify text-xl! flex" data-icon="solar:sort-outline"></i>
  </button>
  @if (isCollapse) {
    <div class="header-collpase py-2.5 px-4">
      <div class="flex justify-center gap-2">
        <!-- --------------------------------------------------------------- -->
        <!-- langugage Dropdown -->
        <!-- --------------------------------------------------------------- -->
        <!-- <button [matMenuTriggerFor]="flags" mat-icon-button>
          <img
            [src]="selectedLanguage.icon"
            class="rounded-full object-cover"
          />
        </button> -->

        <!-- --------------------------------------------------------------- -->
        <!-- Notification Dropdown -->
        <!-- --------------------------------------------------------------- -->
        <button
          class="relative flex items-center justify-center"
          mat-icon-button
          [matMenuTriggerFor]="notificationmenu"
          aria-label="Notifications"
        >
          <i class="iconify flex" data-icon="solar:bell-line-duotone"></i>
          <div
            class="bg-error text-white text-[10px] h-4 w-4 rounded-full leading-3 flex items-center justify-center absolute right-0.5 top-px rtl:right-auto rtl:left-0.5"
          >
            6
          </div>
        </button>

        <!-- --------------------------------------------------------------- -->
        <!-- Inbox Dropdown -->
        <!-- --------------------------------------------------------------- -->
        <button
          class="relative flex items-center justify-center"
          mat-icon-button
          [matMenuTriggerFor]="inboxmenu"
          aria-label="Inbox"
        >
          <i
            class="iconify flex"
            data-icon="solar:settings-minimalistic-line-duotone"
          ></i>
          <div
            class="bg-primary text-white text-[10px] h-4 w-4 rounded-full leading-3 flex items-center justify-center absolute right-0.5 top-px rtl:right-auto rtl:left-0.5"
          >
            3
          </div>
        </button>

        <!-- --------------------------------------------------------------- -->
        <!-- Profile Dropdown -->
        <!-- --------------------------------------------------------------- -->
        <button
          mat-icon-button
          extended
          [matMenuTriggerFor]="profilemenu"
          aria-label="Notifications"
          class="relative flex items-center justify-center p-0! profile-btn-dd"
        >
          <img
            src="/assets/images/profile/user-1.webp"
            class="rounded-full size-9! object-cover profile-dd flex items-center justify-center"
            width="36"
            height="36"
          />
        </button>
      </div>
    </div>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Inbox Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button
    mat-icon-button
    [matMenuTriggerFor]="inboxmenu"
    aria-label="inbox"
    class="hidden! lg:flex! items-center justify-center"
  >
    <i
      class="iconify text-xl! flex"
      data-icon="solar:settings-minimalistic-line-duotone"
    ></i>
  </button>
  <mat-menu
    #inboxmenu="matMenu"
    class="topbar-dd cardWithShadow"
    xPosition="before"
  >
    <div class="flex items-center justify-between px-7.5 py-4">
      <h6 class="text-lg font-semibold">Inbox</h6>
      <span
        class="bg-warning text-white px-2 py-1 font-medium rounded-xl text-xs"
        >3 new</span
      >
    </div>

    @for (inbox of inbox; track inbox.title) {
      <button mat-menu-item class="px-7.5! py-3!">
        <div class="flex gap-4 items-center text-dark">
          <span
            class="relative shrink-0 rounded-full size-12! flex items-center justify-center"
          >
            <img
              class="rounded-full size-12!"
              [src]="inbox.imagePath"
              width="48"
              height="48"
              alt="users"
            />
            <div
              matBadge=""
              matBadgeOverlap="false"
              class="{{
                inbox.bgcolor
              }} demo-section inbox-badge size-2! block absolute! top-0.5 right-0.5 rounded-full"
            ></div>
          </span>
          <div class="w-full">
            <div class="flex items-center justify-between w-full">
              <h5 class="text-sm font-semibold">
                {{ inbox.title }}
              </h5>
              <span class="block text-xs"> {{ inbox.time }}</span>
            </div>
            <span class="block text-truncate text-xs">{{
              inbox.subtitle
            }}</span>
          </div>
        </div>
      </button>
    }

    <div class="py-3 px-7.5">
      <button mat-stroked-button color="primary" class="w-full">
        See All Messages
      </button>
    </div>
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- Profile Dropdown (avatar + nom + badge rôle) -->
  <!-- --------------------------------------------------------------- -->
  <button
    mat-button
    [matMenuTriggerFor]="profilemenu"
    aria-label="Profile"
    class="profile-btn hidden! lg:flex! items-center gap-2 p-1! pr-3!"
  >
    @if (auth.currentUser?.avatarUrl) {
      <img
        [src]="auth.currentUser?.avatarUrl"
        class="rounded-full object-cover size-9!"
        width="36"
        height="36"
      />
    } @else {
      <div
        class="size-9 rounded-full bg-primary/10 text-primary flex items-center justify-center text-sm font-semibold"
      >
        {{ initials }}
      </div>
    }
    <div class="hidden xl:flex flex-col items-start leading-tight">
      <span class="text-sm font-semibold">{{ displayName }}</span>
      <span class="text-[10px] text-muted uppercase tracking-wide">{{
        currentRoleLabel
      }}</span>
    </div>
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <div
      class="flex flex-col items-center gap-3 py-6 border-b border-border px-4 min-w-[260px]"
    >
      @if (auth.currentUser?.avatarUrl) {
        <img
          [src]="auth.currentUser?.avatarUrl"
          class="size-16 rounded-full object-cover"
          width="64"
          height="64"
        />
      } @else {
        <div
          class="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center text-2xl font-bold text-primary"
        >
          {{ initials }}
        </div>
      }
      <div class="flex flex-col items-center gap-1">
        <h6 class="text-base font-semibold m-0">{{ displayName }}</h6>
        <p class="m-0 flex items-center gap-1 text-muted text-xs">
          <i
            class="iconify text-base flex"
            data-icon="solar:mailbox-line-duotone"
          ></i>
          {{ auth.currentUser?.email }}
        </p>
        <span
          class="px-2 py-0.5 mt-1 rounded-full text-[11px] font-semibold bg-primary/10 text-primary"
        >
          {{ currentRoleLabel }}
        </span>
      </div>
    </div>
    <div class="px-3 py-3">
      @for (profile of profiledd; track profile.id) {
        <a
          class="py-2 px-3 flex items-center gap-3 text-muted rounded-lg hover:bg-muted/10 text-sm"
          [routerLink]="[profile.link]"
        >
          <i class="iconify text-xl" [attr.data-icon]="profile.icon"></i>
          <span>{{ profile.title | translate }}</span>
        </a>
      }
    </div>
    <div class="px-4 pb-4 border-t border-border pt-3">
      <button mat-stroked-button color="warn" class="w-full" (click)="logout()">
        <i
          class="iconify text-base mr-2"
          data-icon="solar:logout-line-duotone"
        ></i>
        {{ "common.logout" | translate }}
      </button>
    </div>
  </mat-menu>
</mat-toolbar>
